import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

const WarehouseSupplierOrderSchema = z.object({
  warehouseId: z.string(),
  isSelected: z.boolean(),
  orderVariantId: z.string().nullish(),
  supplierId: z.string().nullish(),
  orderType: z.string().nullish(),
  supplierAccount: z.string().nullish(),
  // Set by the warehouse card from the supplier integration; not sent to the backend.
  isOrderTypeRequired: z.boolean(),
  isSupplierAccountRequired: z.boolean(),
});

export const createSupplierOrdersFormSchema = z
  .object({
    warehouses: z.array(WarehouseSupplierOrderSchema),
  })
  .superRefine((values, context) => {
    values.warehouses.forEach((warehouse, index) => {
      if (!warehouse.isSelected) {
        return;
      }

      const requiredFields = [
        {name: 'orderVariantId', isRequired: true},
        {name: 'supplierId', isRequired: true},
        {name: 'orderType', isRequired: warehouse.isOrderTypeRequired},
        {name: 'supplierAccount', isRequired: warehouse.isSupplierAccountRequired},
      ] as const;

      requiredFields.forEach((field) => {
        if (field.isRequired && isNil(warehouse[field.name])) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
            path: ['warehouses', index, field.name],
          });
        }
      });
    });
  });

export type CreateSupplierOrdersFormValues = z.infer<typeof createSupplierOrdersFormSchema>;
